import MaskTileModel from "../../tile/models/tileModel";
import FillModel from "./fill";
var MaskModels = {
  fill: FillModel,
  vectorMask: MaskTileModel
};
export default MaskModels;